import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PayoutPageContainer } from './PayoutPageContainer';
import { actions } from './PayoutPageContainer.actions';
import { getHeaderNames, getPayouts } from './PayoutPageContainer.selectors';
import { getStatuses } from '../../../../selectors/index';

const mapStateToPropsSelectors = createStructuredSelector({
    headerNames: getHeaderNames,
    payouts: getPayouts,
    selectOptions: getStatuses
});

const PayoutPageContainerComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routingCompat,
            loading: state.publisherPayouts.loading,
            totalPages: state.publisherPayouts.total
        };
    },
    null
)(PayoutPageContainer);

export default PayoutPageContainerComponent;
